'use client';

import { c as _c } from "react/compiler-runtime";
import { useCourseEnrollmentByIdQuery } from '@/generated/graphql';
import { useIsLoggedIn } from '@/lib/hooks/use-is-logged-in';

/**
 * Hook to check if a user is enrolled in a specific course
 * @param courseId - The ID of the course to check enrollment for
 * @returns boolean or undefined - false if user is logged out or on error (graceful failure), undefined if the course enrollment is not loaded (to trigger loading state)
 */
export function useEnrolledInCourse(courseId) {
  const $ = _c(4);
  const isLoggedIn = useIsLoggedIn();
  let t0;
  if ($[0] !== courseId) {
    t0 = {
      id: courseId
    };
    $[0] = courseId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isLoggedIn) {
    t1 = {
      enabled: isLoggedIn
    };
    $[2] = isLoggedIn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const courseEnrollment = useCourseEnrollmentByIdQuery(t0, t1);
  if (!isLoggedIn) {
    return false;
  }
  if (courseEnrollment.isError) {
    return false;
  }
  if (courseEnrollment.isSuccess && !courseEnrollment.data?.course) {
    return false;
  }
  return courseEnrollment.data?.course?.isEnrolled;
}